// haptic feedback not supported on web, so we need to create a dummy function to prevent warnings or errors
export const triggerHapticFeedback = () => {};
